import { render, staticRenderFns } from "./ProposalStateTransitionEngine.vue?vue&type=template&id=34f4b460&scoped=true"
import script from "./ProposalStateTransitionEngine.vue?vue&type=script&lang=js"
export * from "./ProposalStateTransitionEngine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f4b460",
  null
  
)

export default component.exports